import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-label"
}
const _hoisted_2 = { class: "menu-list" }

import MainNavigationListItemVue from "./MainNavigationListItem.vue";
import { TGetAvailablePrograms } from "../Modules/State/Typings/SingleViewStoreTypes";

export interface IMainNavGroup {
  title?: string;
  navItems?: IMainNavItems[];
  activeProgram?: string;
}

export interface IElementConfig {
  hasDropdown?: boolean;
  hasTag?: boolean;
  tagColor?: string;
  tagText?: string;
  hasIcon?: boolean;
}

export interface IMainNavItems {
  label?: string;
  to?: string;
  config?: IElementConfig;
  navChildren?: IMainNavChildren[];
}

export interface IMainNavChildren extends IMainNavItems {
  isLink?: boolean;
  getAvailablePrograms?: TGetAvailablePrograms[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    navItems: null,
    activeProgram: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  navItems?: IMainNavItems[];
  activeProgram?: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (props.navItems?.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.navItems, (item, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createVNode(MainNavigationListItemVue, {
                label: item?.label,
                to: item?.to,
                "nav-children": item?.navChildren,
                "active-program": props.activeProgram,
                config: item?.config
              }, null, 8, ["label", "to", "nav-children", "active-program", "config"])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})